function Pagination({ currentPage, totalPages, setCurrentPage }) {
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    const sideCount = 1;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      let start = Math.max(1, currentPage - sideCount);
      let end = Math.min(totalPages, currentPage + sideCount);

      if (start > 2) {
        pages.push(1, "...");
      } else {
        start = 1;
      }

      for (let i = start; i <= end; i++) pages.push(i);

      if (end < totalPages - 1) {
        pages.push("...", totalPages);
      } else if (end < totalPages) {
        pages.push(totalPages);
      }
    }

    return pages;
  };

  return (
    <nav className="mt-3 d-flex justify-content-end container-md">
      <ul className="pagination flex-wrap">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          >
            &laquo;
          </button>
        </li>

        {getPageNumbers().map((page, idx) => (
          <li
            key={idx}
            className={`page-item ${page === currentPage ? "active" : ""} ${
              page === "..." ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => page !== "..." && setCurrentPage(page)}
              style={{
                minWidth: "36px",
                // color: page === currentPage ? "#4b5c7c" : "",
              }}
            >
              {page}
            </button>
          </li>
        ))}

        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
          >
            &raquo;
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Pagination;
